<template>
  <project-one-toolbar-tab-layout
    id="project-one-toolbar-spec"
    qaid="project-one-toolbar-spec"
    :title="bp('specsTitle')"
    :list="dataList"
  />
</template>

<script>
import axios from 'axios';
import {mapGetters, mapState} from 'vuex';
import stringReplace from '@/mixins/string-replace';
import ProjectOneToolbarTabLayout from '@/projectOne/components/toolbar/components/ProjectOneToolbarTabLayout.vue';
export default {
  name: 'ProjectOneToolbarSpec',
  components: {
    ProjectOneToolbarTabLayout,
  },
  mixins: [stringReplace],
  data() {
    return {
      list: [],
    };
  },
  computed: {
    ...mapState('projectOne', ['selections']),
    ...mapGetters('projectOne', ['packageId']),

    dataList() {
      return this.list.filter((item) => Boolean(item.title) && Boolean(item.description));
    },
  },

  /**
   * Just after this component is created we want to fetch the updated selection array and modules array, loop through selection array
   * to find the groupId and choiceId and then loop thought the modules array
   * to find the description of the matched groupId and choiceId which are present deep in the modules array
   * and push them up in a list array.
   */
  created() {
    const selectionsUrl = `/project-one/api/packages/${this.packageId}/selections/summary/`;

    axios.post(selectionsUrl, {selections: this.selections}).then((response) => {
      const selections = response?.data?.data?.selections;
      const modules = response?.data?.data?.modules;

      selections.forEach((selection) => {
        let groupId = selection.groupId;
        let choiceId = selection.choiceId;

        modules.forEach((module) => {
          let group = module.groups.find((group) => groupId === group.id);

          if (group) {
            let choice = group.choices.find((choice) => choice.id === choiceId);

            if (choice) {
              this.list.push({
                qaid: `project-one-toolbar-spec-${this.stringToKebabCase(group.description)}`,
                title: group.description,
                description: choice.description,
              });
            }
          }
        });
      });
    });
  },
};
</script>
